/* eslint-disable react/no-deprecated */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import ArrowRight from 'yoda-core-components/lib/assets/svg/ArrowRight.svg';
import ArrowLeft from 'yoda-core-components/lib/assets/svg/ArrowLeft.svg';
import { isDesktopWidth } from 'yoda-core-components/lib/helpers/Utils/mediaQuery';
import _isEmpty from 'lodash/isEmpty';
import * as styles from './HorizontalSlider.css';

const cx = classNames.bind(styles);

export class HorizontalSlider extends PureComponent {
    static defaultProps = {
        wrapperClass: '',
        contentWrapperClass: '',
        customLeftButtonSliderClass: '',
        customRightButtonSliderClass: '',
        imageHeight: () => {},
    };

    static propTypes = {
        wrapperClass: PropTypes.string,
        children: PropTypes.element.isRequired,
        contentWrapperClass: PropTypes.string,
        customLeftButtonSliderClass: PropTypes.string,
        customRightButtonSliderClass: PropTypes.string,
        imageHeight: PropTypes.func,
    };

    scrollPosition = 0;

    listParentRef = null;

    constructor() {
        super();
        this.state = {
            disableLeftArrow: true,
            disableRightArrow: false,
            animateWrapperClass: '',
        };
    }

    componentDidMount() {
        if (!isDesktopWidth()) return;
        this.disableArrowCheck();
        window.addEventListener('scroll', this.onScrollTransition.bind(this));
        window.addEventListener('resize', this.onResizeCallback.bind(this));
    }

    componentWillReceiveProps(nextProps) {
        const { children = {} } = this.props;
        const { children: nextPropsChildren = {} } = nextProps || {};
        if (isDesktopWidth() && nextPropsChildren !== children) {
            this.scrollPosition = 0;
            this.disableArrowCheck();
        }
    }

    componentWillUnmount() {
        if (!isDesktopWidth()) return;
        if (!__SERVER__) {
            window.removeEventListener('scroll', this.onScrollTransition.bind(this));
            window.removeEventListener('resize', this.onResizeCallback.bind(this));
        }
    }

    onResizeCallback = () => {
        this.disableArrowCheck();
    };

    onScrollTransition = () => {
        // pageYOffset is compatable with all browsers
        const currentScrollTop = window.pageYOffset;
        const { disableLeftArrow, disableRightArrow } = this.state;

        if (this.isComponentVisible() && !(disableLeftArrow && disableRightArrow)) {
            /* istanbul ignore next */
            const wrapperTransitionClass =
                this.previousScrollTop > currentScrollTop ? 'animateRight' : 'animateLeft';
            this.setState({
                animateWrapperClass: wrapperTransitionClass,
                animateButtonsClass: 'addButtonAnimation',
            });
        } else {
            this.setState({ animateButtonsClass: 'removeButtonAnimation' });
        }
        this.previousScrollTop = currentScrollTop;
    };

    getDimensions() {
        if (!this.wrapperRef || !this.listParentRef) return {};
        const { width: wrapperWidth } = this.wrapperRef.getBoundingClientRect() || {};
        const { scrollWidth: parentWidth, childElementCount } = this.listParentRef;
        return {
            wrapperWidth,
            parentWidth,
            childElementCount,
        };
    }

    getListParentRef = (ref) => {
        this.listParentRef = ref || {};
    };

    isComponentVisible = () => {
        if (!this.listParentRef || _isEmpty(this.listParentRef)) return false;
        const { top = 0, height = 0 } = this.listParentRef.getBoundingClientRect() || {};
        const { innerHeight } = window;
        const { documentElement: { clientHeight } = {} } = document;
        const windowInnerHeight = innerHeight || clientHeight || 0;
        const heightPoint = height / 4;
        const showContent =
            top + height - heightPoint <= windowInnerHeight && top + heightPoint >= 0;
        return showContent;
    };

    getNewScrollPosition = (wrapperWidth, parentWidth, childElementCount) => {
        const childWidth = parentWidth / childElementCount;
        let childCountWidth = 0;
        // eslint-disable-next-line no-plusplus
        for (let i = 1; i <= childElementCount; i++) {
            childCountWidth = i * childWidth;
            if (childCountWidth > wrapperWidth) {
                break;
            } else childCountWidth = 0;
        }
        return childCountWidth > 0 ? childCountWidth - childWidth : wrapperWidth;
    };

    scrollCartridge = (scrollToRight) => () => {
        const { wrapperWidth = 0, parentWidth = 0, childElementCount = 0 } =
            this.getDimensions() || {};
        const maxMoveToLeft = 0;
        const maxMoveToRight = wrapperWidth - parentWidth;
        if (scrollToRight) {
            const newScrollPosition =
                this.scrollPosition -
                this.getNewScrollPosition(wrapperWidth, parentWidth, childElementCount);
            this.scrollPosition =
                newScrollPosition >= maxMoveToRight ? newScrollPosition : maxMoveToRight;
        } else {
            const newScrollPosition =
                this.scrollPosition +
                this.getNewScrollPosition(wrapperWidth, parentWidth, childElementCount);
            this.scrollPosition =
                newScrollPosition <= maxMoveToLeft ? newScrollPosition : maxMoveToLeft;
        }
        if (this.listParentRef)
            this.listParentRef.style.transform = `translate(${this.scrollPosition}px)`;
        this.disableArrowCheck();
    };

    disableArrowCheck = () => {
        const { wrapperWidth = 0, parentWidth = 0, childElementCount = 0 } =
            this.getDimensions() || {};
        const maxMoveToLeft = 0;
        const maxMoveToRight = wrapperWidth - parentWidth;
        /* istanbul ignore next */
        const rightArrowCheck = this.scrollPosition <= maxMoveToRight || childElementCount <= 4;
        const leftArrowCheck = this.scrollPosition >= maxMoveToLeft || childElementCount <= 4;
        this.setState({
            /* istanbul ignore next */
            animateWrapperClass: (rightArrowCheck || leftArrowCheck) && '',
            disableRightArrow: rightArrowCheck,
            disableLeftArrow: leftArrowCheck,
        });
    };

    renderNavigationButtons = () => {
        const { disableLeftArrow, disableRightArrow, animateButtonsClass } = this.state;
        const leftArrowClass = cx({ iconClass: true, disabledArrow: disableLeftArrow });
        const rightArrowClass = cx({ iconClass: true, disabledArrow: disableRightArrow });
        if (disableLeftArrow && disableRightArrow) return null;
        const {
            customLeftButtonSliderClass,
            customRightButtonSliderClass,
            imageHeight,
        } = this.props;
        const btnPositionStyle = imageHeight
            ? { margin: '0px', top: `${imageHeight / 2 - 21.9}px` }
            : null;
        return (
            <>
                <button
                    type="button"
                    className={cx(
                        'arrow',
                        'leftArrow',
                        customLeftButtonSliderClass,
                        animateButtonsClass
                    )}
                    disabled={disableLeftArrow}
                    onClick={this.scrollCartridge(false)}
                    style={btnPositionStyle}
                >
                    <Icon
                        iconType="svg"
                        className="arrow-icon"
                        width="19.5px"
                        height="29px"
                        viewBox="0 0 20 20"
                        pathClassName={leftArrowClass}
                    >
                        <ArrowLeft />
                    </Icon>
                </button>
                <button
                    type="button"
                    className={cx(
                        'arrow',
                        'rightArrow',
                        customRightButtonSliderClass,
                        animateButtonsClass
                    )}
                    disabled={disableRightArrow}
                    onClick={this.scrollCartridge(true)}
                    style={btnPositionStyle}
                >
                    <Icon
                        iconType="svg"
                        className="arrow-icon"
                        width="19.5px"
                        height="29px"
                        viewBox="0 0 20 20"
                        pathClassName={rightArrowClass}
                    >
                        <ArrowRight />
                    </Icon>
                </button>
            </>
        );
    };

    render() {
        const { wrapperClass, contentWrapperClass, children } = this.props;
        const { animateWrapperClass } = this.state;
        const extraPropsToChildren = isDesktopWidth()
            ? {
                  listParentRef: this.getListParentRef,
              }
            : {};
        const wrapperClassOndeviceType = !isDesktopWidth() && 'mobileSlider';
        const childrenElement = React.cloneElement(children, extraPropsToChildren);
        return (
            <div className={cx('sliderWrapper', wrapperClass, wrapperClassOndeviceType)}>
                <div
                    className={cx('contentWrapper', contentWrapperClass, animateWrapperClass)}
                    ref={(el) => {
                        this.wrapperRef = el;
                    }}
                >
                    {childrenElement}
                </div>
                {this.listParentRef && isDesktopWidth() && this.renderNavigationButtons()}
            </div>
        );
    }
}

export default HorizontalSlider;
